import { LcsDateTimeFormats } from './date-time-formats';

export const LCS_NATIVE_DATE_TIME_FORMATS: LcsDateTimeFormats = {
   parse: {
      dateInput: null,
      dateTimeInput: null,
   },
   display: {
      // see https://tc39.es/ecma402/#datetimeformat-objects
      dateInput: { year: 'numeric', month: '2-digit', day: '2-digit' },
      dateTimeInput: [
         { year: 'numeric', month: '2-digit', day: '2-digit' },
         { hour: '2-digit', minute: '2-digit' },
      ],
      monthYearLabel: { year: 'numeric', month: 'short' },
      dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
      monthYearA11yLabel: { year: 'numeric', month: 'long' },
      hours: { hour: '2-digit' },
      minutes: { minute: '2-digit' },
      timeA11yLabel: { hour: 'numeric', minute: '2-digit' },
   },
};

export const LCS_RELATIVE_NATIVE_DATE_TIME_FORMATS: LcsDateTimeFormats = {
   parse: LCS_NATIVE_DATE_TIME_FORMATS.parse,
   display: {
      dateInput: { year: 'numeric', month: '2-digit', day: '2-digit', formatRelativeDate: false },
      dateTimeInput: [
         { year: 'numeric', month: '2-digit', day: '2-digit', formatRelativeDate: false },
         { hour: '2-digit', minute: '2-digit', formatRelativeDate: false },
      ],
      monthYearLabel: { year: 'numeric', month: 'short' },
      dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
      monthYearA11yLabel: { year: 'numeric', month: 'long' },
      hours: { hour: '2-digit' },
      minutes: { minute: '2-digit' },
      timeA11yLabel: { hour: 'numeric', minute: '2-digit' },
   },
};
